/* ==========================================================================
   assets/ssuk-hp.js                                      SSUK homepage sections

   The hero rotator, built to the Screwfix pattern - the only one of thirty
   competitor heroes reviewed that does this properly:

     - three slides, 6s on desktop
     - NO autoplay below 768px (Baymard: mobile carousels must not rotate)
     - a real pause control, labelled for screen readers (WCAG 2.2.2)
     - prefers-reduced-motion stops auto-advance entirely
     - pauses on hover, on keyboard focus, and when the tab is hidden

   Written for the theme editor as well as the storefront: each instance is
   bound to its own section root, torn down on shopify:section:unload, and
   selecting a slide block in the editor shows that slide.

   The VAT toggle is NOT here. assets/ssuk-vat.js owns it store-wide.
   ========================================================================== */
(function () {
  "use strict";

  var DESKTOP = window.matchMedia("(min-width: 768px)");
  var CALM = window.matchMedia("(prefers-reduced-motion: reduce)");
  var DELAY = 6000;

  var PAUSE_ICON =
    '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
    '<rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>';
  var PLAY_ICON =
    '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5l11 7-11 7z"/></svg>';

  var instances = {};

  function Hero(root) {
    var hero = root.querySelector(".hp-hero");
    if (!hero) return null;

    var slides = [].slice.call(hero.querySelectorAll(".hp-slide"));
    var copies = [].slice.call(hero.querySelectorAll(".hp-hero__copy"));
    var dots = [].slice.call(hero.querySelectorAll("[data-hero-dot]"));
    var pauseB = hero.querySelector('[data-hero="pause"]');
    var prevB = hero.querySelector('[data-hero="prev"]');
    var nextB = hero.querySelector('[data-hero="next"]');

    var i = 0,
      timer = null,
      stopped = false;

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, x) {
        s.classList.toggle("hp-is-active", x === i);
      });
      copies.forEach(function (c, x) {
        c.hidden = x !== i;
      });
      dots.forEach(function (d, x) {
        d.setAttribute("aria-current", x === i ? "true" : "false");
      });
    }

    function canPlay() {
      return slides.length > 1 && DESKTOP.matches && !CALM.matches && !stopped;
    }
    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }
    function play() {
      stop();
      if (canPlay()) {
        timer = setInterval(function () {
          show(i + 1);
        }, DELAY);
      }
    }

    // A single slide still renders; it just never rotates and has no controls.
    if (slides.length < 2) {
      show(0);
      return { destroy: function () {}, goTo: show };
    }

    if (prevB)
      prevB.addEventListener("click", function () {
        show(i - 1);
        play();
      });
    if (nextB)
      nextB.addEventListener("click", function () {
        show(i + 1);
        play();
      });
    dots.forEach(function (d, x) {
      d.addEventListener("click", function () {
        show(x);
        play();
      });
    });

    if (pauseB) {
      pauseB.addEventListener("click", function () {
        stopped = !stopped;
        pauseB.setAttribute(
          "aria-label",
          stopped ? "Start automatic slide show" : "Stop automatic slide show"
        );
        pauseB.innerHTML = stopped ? PLAY_ICON : PAUSE_ICON;
        play();
      });
    }

    function onVis() {
      document.hidden ? stop() : play();
    }

    hero.addEventListener("mouseenter", stop);
    hero.addEventListener("mouseleave", play);
    hero.addEventListener("focusin", stop);
    hero.addEventListener("focusout", play);
    document.addEventListener("visibilitychange", onVis);
    // addEventListener on MediaQueryList is not in older Safari; guard it.
    if (DESKTOP.addEventListener) {
      DESKTOP.addEventListener("change", play);
      CALM.addEventListener("change", play);
    } else if (DESKTOP.addListener) {
      DESKTOP.addListener(play);
      CALM.addListener(play);
    }

    show(0);
    play();

    return {
      goTo: show,
      destroy: function () {
        stop();
        document.removeEventListener("visibilitychange", onVis);
        if (DESKTOP.removeEventListener) {
          DESKTOP.removeEventListener("change", play);
          CALM.removeEventListener("change", play);
        }
      }
    };
  }

  function mount(root) {
    if (!root) return;
    var id = root.dataset.sectionId || "hp";
    if (instances[id]) instances[id].destroy();
    var h = Hero(root);
    if (h) instances[id] = h;
  }

  function mountAll() {
    [].slice
      .call(document.querySelectorAll("[data-ssuk-hp-hero]"))
      .forEach(mount);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mountAll);
  } else {
    mountAll();
  }

  // Theme editor: re-render, teardown, and "show me the slide I just clicked".
  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target.querySelector("[data-ssuk-hp-hero]");
    if (root) mount(root);
  });
  document.addEventListener("shopify:section:unload", function (e) {
    var root = e.target.querySelector("[data-ssuk-hp-hero]");
    if (root && instances[root.dataset.sectionId]) {
      instances[root.dataset.sectionId].destroy();
      delete instances[root.dataset.sectionId];
    }
  });
  document.addEventListener("shopify:block:select", function (e) {
    var root = e.target.closest("[data-ssuk-hp-hero]");
    if (!root) return;
    var inst = instances[root.dataset.sectionId];
    var idx = parseInt(e.target.dataset.slideIndex, 10);
    if (inst && !isNaN(idx)) inst.goTo(idx);
  });
})();
